import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Button } from '../../../../common/html/button'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../helpers/EventEmitter'
import style from '../index.module.scss'
import { selectTotal } from '../store/slice/slice'
import { downloadSavedPortfolio } from '../store/thunk'

export const GroupBtn = ({ setIsShowCreateForm }) => {
  const dispatch = useDispatch()

  const { totalPortfolios } = useSelector(selectTotal)
  const textValidate = UseI18n('library.main.VALIDATE_PORTFOLIO')

  const handleCreatePortfolio = () => {
    if (totalPortfolios >= 300) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [textValidate],
      })
      return null
    }
    setIsShowCreateForm((prev) => !prev)
  }

  const handleExport = () => {
    dispatch(downloadSavedPortfolio())
  }

  return (
    <div className={['dFlex justifyContentBetween  ', style.action].join(' ')}>
      <Button
        className={style.createBtn}
        style={{
          color: '#ffffff',
          backgroundColor: '#2c73e8',
        }}
        label="library.savePortfolio.CREATE_PORTFOLIO"
        action={handleCreatePortfolio}
        isI18n
      />
      <Button
        className={style.export}
        style={{
          borderColor: '#6d9dcf',
          color: '#2c73e8',
          backgroundColor: '#ffffff',
          minWidth: 100,
        }}
        label="library.savePortfolio.EXPORT"
        action={handleExport}
        isI18n
      />
    </div>
  )
}
